import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.SpendTrackerUncategorizedCard`

export default defineMessages({
  uncategorizedLabel: {
    id: `${scope}.uncategorizedLabel`,
    defaultMessage: 'Uncategorized',
  },
})
